import styles from '../components/map-styles'

const AddMarker = (map, lat, lng) => {
  const marker = new google.maps.Marker({
    map: map,
    icon: {
      url: '/dist/img/default/pin.png',
      scaledSize: new google.maps.Size(35, 35)
    },
    position: new google.maps.LatLng(lat, lng),
    title: 'STAMPA'
  })
}
const SetGeneralMap = (mapContainer) => {
  const lat = mapContainer.getAttribute('lat')
  const lng = mapContainer.getAttribute('lng')
  const latLngDefault = new google.maps.LatLng(lat, lng)

  const map = new google.maps.Map(mapContainer, {
    center: latLngDefault,
    disableDefaultUI: true,
    zoom: 15,
    zoomControl: true,
    styles: styles
  })

  AddMarker(map, lat, lng)
}

export const SingleMap = () => {
  const mapContainer = document.querySelector('#single-map')

  if (!mapContainer) return

  window.addEventListener('load', () => {
    SetGeneralMap(mapContainer)
  })
}

export default SingleMap
